/**
 * Google Analytics 4 (gtag) event helpers.
 *
 * The base GA4 tag (G-1J0MZ997NS) is injected in /public/index.html and
 * exposes window.gtag. These wrappers fire the three Pivotbox-funnel
 * conversion events:
 *
 *   gaGenerateLead()                        — S0 (Founder Signal Test) start
 *   gaBeginCheckout()                       — ₹3,999 paywall CTA clicked
 *   gaPurchase({ transactionId })           — payment verified (₹3,999)
 *
 * All helpers swallow errors so analytics never breaks the app.
 */
function safeGtag(...args) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return; // gtag.js not loaded / blocked
  try {
    window.gtag(...args);
  } catch (e) {
    /* swallow — analytics must never break the app */
  }
}

export function gaGenerateLead() {
  safeGtag("event", "generate_lead");
}

export function gaBeginCheckout({ value = 3999, currency = "INR" } = {}) {
  safeGtag("event", "begin_checkout", { currency, value });
}

export function gaPurchase({ value = 3999, currency = "INR", transactionId } = {}) {
  safeGtag("event", "purchase", {
    currency,
    value,
    ...(transactionId ? { transaction_id: transactionId } : {}),
  });
}

export function gaGenerateLeadS0() {
  // Fired when the visitor lands on /s0-report/:id (S0 assessment completed).
  safeGtag("event", "generate_lead");
}

export function gaSignUp() {
  // Fired when the visitor submits the S0 name + mobile form, immediately
  // before the report/PDF is generated.
  safeGtag("event", "sign_up");
}
